import {
  CertificationFilter,
  CertificationsQuery,
  CertificationsQueryVariables,
  SortOrder,
} from '__generated__/graphql';
import { CERTIFICATION_QUERY } from 'apollo/queries/certification-queries';
import useGraphQLPaging from 'hooks/graphql/useGraphQLPaging/useGraphQLPaging';
import { useCallback } from 'react';

export const useGetCertifications = () => {
  const pager = useGraphQLPaging();

  return useCallback(
    async (filter?: CertificationFilter) => {
      return pager<CertificationsQuery, CertificationsQueryVariables>(
        {
          document: CERTIFICATION_QUERY,
          variables: {
            filter: {
              ...filter,
              deletedOn: {
                isNull: true,
              },
            },
            sort: [{ name: SortOrder.Asc }],
          },
        },
        'certifications'
      );
    },
    [pager]
  );
};
